import { formatDataReviewDisplayLabel } from "../../../Contributor/Stages/BackgroundData/utils/backgroundDataReviewers";
import type { DropdownOption } from "../../../../../interfaces/dropdownInterfaces";

function humanizeSlug(value: string): string {
  return value
    .split("_")
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

export function formatReliabilityDropdownLabel(
  options: DropdownOption[],
  raw: string | null | undefined
): string {
  const value = String(raw ?? "").trim();
  if (!value) return "-";

  const match = (options || []).find((option) => String(option.value ?? "") === value);
  if (match?.label) return String(match.label);

  return humanizeSlug(value);
}

export function formatSubmissionDataReviewLabel(
  raw: string | null | undefined,
  dataReviewOptions: DropdownOption[]
): string {
  const value = String(raw ?? "").trim();
  if (!value) return "-";
  return formatDataReviewDisplayLabel(value, dataReviewOptions);
}
